import React from "react";

const DoneMark = ({ done, height }) => {
  return (
    <div>
      {done ? (
        <svg role="done" width={height} height={height} viewBox="0 0 32 32">
          <path
            d="M28 4L12 28 4 20"
            stroke="#FFFFFF"
            strokeWidth={4}
            fill="none"
          />
        </svg>
      ) : (
        <svg role="missed" width={height} height={height} viewBox="0 0 32 32">
          <path
            d="M4 4L28 28M4 28L28 4"
            stroke="#ff3852"
            strokeWidth={4}
            fill="none"
          />
        </svg>
      )}
    </div>
  );
};

export default DoneMark;
